// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNotAllowed = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0m-2 0a7 7 0 01-11.19 5.608l9.798-9.799A6.97 6.97 0 0119 12M6.395 16.194l9.799-9.8a7 7 0 00-9.799 9.799"
    />
  );
export default SvgIconNotAllowed;
